import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGlobalState } from "../../GlobalProvider";
import TableNav from "../../components/TableNav";
import { getBookingList, updateBookingServ } from "../../services/appointment.service";
import Skeleton from "react-loading-skeleton";
import NoRecordFound from "../../components/NoRecordFound";
import moment from "moment";
import AppointmentRequest from "./AppointmentRequest";
function AppointmentFixed() {
  const [showSkelton, setShowSkelton] = useState(false);
  const [list, setList] = useState([]);
  const handleGetBookingList = async () => {
    if(list?.length==0){
      setShowSkelton(true);
    }
    
    try {
      let response = await getBookingList({ status: "kundaliAdded" });
      if (response?.data?.success) {
        setList(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
    setShowSkelton(false);
  };
  useEffect(() => {
    handleGetBookingList();
  }, []);
 
   const updateBookingFunc =async (id, formData)=>{
      try {
        let response = await updateBookingServ(id, formData);
        if(response?.data?.statusCode==200){
          toast.success(response?.data.message);
          handleGetBookingList();
        }
      } catch (error) {
        toast.success(error?.response?.data.message || "Internal Server Error");
      }
    }
  return (
    <div className="main_layout  bgBlack d-flex">
      {/* sectionLayout started */}
      <section className="section_layout d-flex">
        {/* sidebar started */}
        <Sidebar selectedItem="Token" />
        {/* sidebar ended */}
        <div className="w-100 me-5">
          <div className="ms-5 w-100">
            <div className="">
              <div className="tableBody borderRadius50All">
                <div>
                  <table className="table ">
                    <thead>
                      <tr style={{ background: "#00631A", color: "#fff" }}>
                        <th scope="col" style={{ borderRadius: "24px 0px 0px 24px" }}>
                          <div className="d-flex justify-content-center ms-2">
                            <span className="mx-2">Sr. No</span>
                          </div>
                        </th>
                        <th scope="col">Location</th>
                        <th scope="col">Full Name</th>
                        <th scope="col">Contact Number</th>
                        <th scope="col">City</th>
                        <th scope="col">No. of kundali</th>
                        <th scope="col">Extra Time</th>
                        <th scope="col">Schedule Time</th>
                        <th scope="col">Token Numbr</th>
                        <th scope="col" style={{ borderRadius: "0px 24px 24px 0px" }}>
                          Mark Done
                        </th>
                      </tr>
                    </thead>

                    <div className="pt-3 pb-2 "></div>
                    <tbody className="driverTable">
                      {showSkelton
                                              ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((v, i) => {
                                                return (
                                                  <tr className=" ">
                                                    <td>
                                                      <Skeleton width={40} height={20} />
                                                    </td>
                                                    <td>
                                                      <Skeleton width={100} height={20} />
                                                    </td>
                                                    <td>
                                                      <Skeleton width={100} height={20} />
                                                    </td>
                                                    <td>
                                                      <Skeleton width={100} height={20} />
                                                    </td>
                                                    <td>
                                                      <Skeleton width={100} height={20} />
                                                    </td>
                                                    <td>
                                                      <Skeleton width={100} height={20} />
                                                    </td>
                                                    <td>
                                                      <Skeleton width={100} height={20} />
                                                    </td>
                                                    <td>
                                                      <Skeleton width={100} height={20} />
                                                    </td>
                                                    <td>
                                                      <Skeleton width={100} height={20} />
                                                    </td>
                                                    <td>
                                                      <Skeleton width={100} height={20} />
                                                    </td>
                                                  </tr>
                                                );
                                              }):list?.map((v, i) => (
                        <>
                          <tr
                            key={i}
                            style={{
                              background: i % 2 === 0 ? "#F2D7D0" : "#E7E7E7",
                              cursor: "pointer",
                              border: "2px solid red",
                            }}
                          >
                            <td scope="row" style={{ borderRadius: "12px 0px 0px 12px" }}>
                              {i + 1}
                            </td>
                            <td>{v?.location}</td>
                            <td>{v?.fullName}</td>
                            <td>
                              {v?.countryCode} {v?.contact}
                            </td>
                            <td>{v?.yourCity}</td>
                            <td>{v?.noOfKundali}</td>
                            <td>{v?.extraTime ? v?.extraTime : 0} mins</td>

                            <td>{v?.scheduledTime}</td>
                            <td>{v?.tokenNo}</td>
                            <td style={{ borderRadius: "0px 12px 12px 0px" }}>
                              <button
                                className="btn btn-primary me-2"
                                style={{
                                  marginTop: "-6px",
                                  background: "#1F1E30",
                                  borderRadius: "6px",
                                  border: "none",
                                  width: "100px",
                                  color: "#fff",
                                }}
                                onClick={()=>updateBookingFunc(v?._id, {status:"completed"})}
                              >
                                Yes
                              </button>
                            </td>
                          </tr>
                          {/* <tr key={i} style={{ background: i % 2 === 0 ? "#F2D7D0" : "#E7E7E7", cursor: "pointer", border:"2px solid red" }}>
                          <td scope="row"  style={{  borderRadius: "12px 0px 0px 12px" }}>{i + 1}</td>

                          <td>Chandigarh</td>
                          <td>Sandeep Singh</td>
                          <td>+91 98765-43210</td>

                          <td>Ambala</td>
                          <td>{i * 2 + 1}</td>
                          <td>15 mins</td>
                          <td>12-11-2024</td>
                          <td>03:30 PM</td>

                          <td style={{ borderRadius: "0px 12px 12px 0px" }}>
                            <button
                              className="btn btn-primary"
                              style={{ marginTop: "-6px", background: "#7650E0", borderRadius: "6px", border: "none", width:"100px" }}
                            >
                              20
                            </button>
                          </td>
                        </tr> */}
                          <div className="py-2"></div>
                        </>
                      ))}
                    </tbody>
                  </table>
                  {list?.length == 0 && !showSkelton && <NoRecordFound theme="light" />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* sectionLayout ended */}
    </div>
  );
}

export default AppointmentFixed;
